<template>
  <div>
    <v-icon :size="15" @click="dialogDetalhamentoEstoque = true;getDadosUltimasCompras();" title="Detalhamento das últimas compras">mdi-information-outline</v-icon>

    <v-dialog
      v-model="dialogDetalhamentoEstoque" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="#042333">
          <v-btn icon dark  @click="dialogDetalhamentoEstoque = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title> Últimas Compras Grupo</v-toolbar-title>

          <ConverterEmbalagem />
        </v-toolbar>

        <v-card-text class="px-0 pb-0">
          <div class="d-flex align-center pt-3 pb-2 px-5">
            <DesconsiderarPedidoEmTransito
              v-if="compras_selecionadas.filter(item => item.qtde_pendente > 0 || item.pedido_desconsiderado).length > 0"
              :pedidos="compras_selecionadas.filter(item => item.qtde_pendente > 0 || item.pedido_desconsiderado)"
              habilitar_botao_grande
              :idgrupo="produto.id_grupo"
              @update:desconsiderar-pedido-em-transito="updatePedidoEmTransitoDesconsiderado"
            />

            <v-spacer />

            <div class="w-500">
              <v-text-field
                v-model="pesquisa"
                append-icon="mdi-magnify"
                label="Pesquisar"
                dense
                hide-details
                clearable
                v-lazy-input:debounce="500"
              />
            </div>
          </div>

          <v-data-table
            v-model="compras_selecionadas"
            :search="pesquisa"
            :headers="cabecalhos_computed"
            :items="ultimas_compras"
            :fixed-header="true"
            :items-per-page="-1"
            show-select
            item-key="index_row"
            height="calc(100vh - 165px)"
            class="table-full-screen ml-2"
            :item-class="itemClass"
          >
            <template #item.data-table-select="{item, select, isSelected}">
              <v-btn v-if="item.qtde_pendente > 0 || item.pedido_desconsiderado" icon @click="select(!isSelected)">
                <v-icon v-if="isSelected">mdi-checkbox-marked</v-icon>
                <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
              </v-btn>

              <v-btn v-else icon disabled>
                <v-icon>mdi-checkbox-blank-outline</v-icon>
              </v-btn>
            </template>

            <template #item.filial="{item}">
              {{ item.filial }}
              <span v-if="item.nome_fantasia"> - {{ item.nome_fantasia }}</span>
            </template>

            <template #item.data_solicitacao="{item}">
              {{ formatarData(item.data_solicitacao) }}
            </template>

            <template #item.data_previsao="{item}">
              {{ formatarData(item.data_previsao) }}
            </template>

            <template #item.data_entrega="{item}">
              {{ formatarData(item.data_entrega) }}
            </template>

            <template #item.data_faturamento="{item}">
              {{ formatarData(item.data_faturamento) }}
            </template>

            <template #item.unidade_compra="{item}">
              {{ embalagemMasterAtivada ? item.unidade_master : item.unidade_compra }}
            </template>

            <template #item.qtde="{item}">
              {{ Helpers.formatarValor(converteEmbalagemValor(item, item.qtde)) }}
            </template>

            <template #item.qtde_entregue="{item}">
              {{ Helpers.formatarValor(converteEmbalagemValor(item, item.qtde_entregue)) }}
            </template>

            <template #item.qtde_faturada="{item}">
              {{ Helpers.formatarValor(converteEmbalagemValor(item, item.qtde_faturada)) }}
            </template>

            <template #item.qtde_pendente="{item}">
              {{ Helpers.formatarValor(converteEmbalagemValor(item, item.qtde_pendente)) }}
            </template>

            <template #item.preco_compra="{ item }">
              <FormatarMoeda :tipo="item.moeda" />
              {{ Helpers.formatarValorComCasas(item.preco_compra, 2) }}
            </template>

            <template #item.punit="{ item }">
              <FormatarMoeda :tipo="item.moeda" />
              {{ Helpers.formatarValorComCasas(item.punit, 2) }}
            </template>

            <template #item.punitant="{ item }">
              <FormatarMoeda :tipo="item.moeda" />
              {{ Helpers.formatarValorComCasas(item.punitant, 2) }}
            </template>

            <template #item.total_compra="{ item }">
              <FormatarMoeda :tipo="item.moeda" />
              {{ Helpers.formatarValorComCasas(item.total_compra, 2) }}
            </template>

            <template #item.indicador_preco="{item}">
              <div v-if="parseFloat(item.indicador_preco) > 0" class="text-center">
                <v-icon :title="`${Helpers.formatarValor(item.indicador_preco)}%`" color="red darken-2">mdi-arrow-up</v-icon>
              </div>

              <div v-else-if="parseFloat(item.indicador_preco) < 0" class="text-center" >
                <v-icon :title="`${Helpers.formatarValor(item.indicador_preco)}%`" color="green darken-2">mdi-arrow-down</v-icon>
              </div>

              <div v-else class="text-center">-</div>
            </template>

            <template #item.compra_programada="{item}">
              {{ item.compra_programada === 'S' ? 'SIM' : 'NÃO' }}
            </template>

            <template #item.atraso="{item}">
              <div class="text-center">
                <div class="text-green" v-if="parseInt(item.atraso) < 0">
                  {{ Math.abs(item.atraso) }}
                </div>
                <div v-if="parseInt(item.atraso) === 0">
                  {{ Math.abs(item.tempo_entrega) }}
                </div>
                <div class="text-red" v-if="parseInt(item.atraso) > 0">
                  {{ item.atraso }} atraso
                </div>
              </div>
            </template>

            <template #item.acoes="{item}">
              <DesconsiderarPedidoEmTransito
                v-if="item.qtde_pendente > 0 || item.pedido_desconsiderado"
                :idgrupo="produto.id_grupo"
                :pedidos="[item]"
                @update:desconsiderar-pedido-em-transito="updatePedidoEmTransitoDesconsiderado"
              />
            </template>

            <template #footer.prepend>
              <div class="d-flex align-center">
                <div class="d-flex align-center">
                  <v-icon size="24" color="red" class="mr-1">mdi-truck-delivery</v-icon>
                  Pedido em trânsito
                </div>

                <div class="d-flex align-center ml-5">
                  <v-icon size="24" class="mr-1">$TruckRemove</v-icon>
                  Pedido desconsiderado
                </div>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CompraAPI from "../../../../api/compra"
import ConverterEmbalagem from "@/components/compra/Embalagem/ConverterEmbalagem";
import {logout} from "@/helpers";
import DesconsiderarPedidoEmTransito from "@/components/produto/detalhes/UltimasCompras/DesconsiderarPedidoEmTransito";
import api from "@/api/api";
import FormatarMoeda from "@/components/utils/FormatarMoeda.vue";

export default {
  name: 'UltimasCompras',
  components: {
    DesconsiderarPedidoEmTransito,
    ConverterEmbalagem,
    FormatarMoeda
  },
  props: {
    produto: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialogDetalhamentoEstoque: false,
      referenciaSelecionada1: false,
      ultimas_compras: [],
      compras_selecionadas: [],
      pesquisa: '',
      atualizar_listagem_produtos: false
    }
  },
  computed: {
    embalagemMasterAtivada() {
      return this.$store.getters["EmbalagemTelaDeCompras/getEmbalagemMaster"];
    },
    cabecalhos_computed() {
      const cabecalhos = [
        { text: "Razão Social", value: "fornecedor" },
        { text: "Filial", value: "filial" },
        { text: "Pedido", value: "ordem_compra" },
        { text: "Produto", value: "produto" },
        { text: "Item", value: "item" },
        { text: "Dt. Solicitação", value: "data_solicitacao" },
        { text: "Dt. Previsão", value: "data_previsao" },
        { text: "Dt. Entrada", value: "data_entrega" },
        { text: "Dt. Faturamento", value: "data_faturamento" },
      ];

      if (this.ultimas_compras.some(item => item.compra_programada === 'S')) {
        cabecalhos.push({text: "Dt. Liberação", value: "data_liberacao"});
        cabecalhos.push({text: "Compra Programada", value: "compra_programada"});
      }

      cabecalhos.push(
        { text: "UND", value: "unidade_compra" },
        { text: "Qntd Pendente", value: "qtde_pendente" },
        { text: "Qntd Entregue", value: "qtde_entregue" },
        { text: "Qntd Faturada", value: "qtde_faturada" },
        { text: "Qntd Total", value: "qtde" },
        { text: "Valor Unit. Liquido", value: "preco_compra" },
        { text: "Valor Unit. Bruto", value: "punit" },
        { text: "Valor Unitário Ant.", value: "punitant" },
        { text: "Total", value: "total_compra" },
        { text: "Indicador", value: "indicador_preco" },
        { text: "Tempo entrega dia(s)", value: "atraso" },
        { text: "Ações", value: "acoes" },
      );

      return cabecalhos;
    },
  },
  watch: {
    dialogDetalhamentoEstoque() {
      if (!this.dialogDetalhamentoEstoque && this.atualizar_listagem_produtos) {
        this.atualizar_listagem_produtos = false;
        this.$emit("atualizar-listagem-produtos", {});
      }
    }
  },
  methods: {
    getDadosUltimasCompras() {
      this.ultimas_compras = [];
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        produto: this.produto.id_produto,
        produtos: this.produto.produtos,
        filial: this.produto.filial == 9999 ? 0 : this.produto.filial,
        grupo: this.produto.id_grupo,
        rows: 1000,
        produto_eh_combinacao: this.produto.produto_eh_combinacao ? 'S' : 'N',
      };

      api.post('compras_listacompras_grupo', params)
        .then(response => {
          const { token, compras } = response.data;
          localStorage.setItem("token", token);
          this.ultimas_compras = compras.map((item) => {
            item.data_solicitacao = typeof item.data_solicitacao === 'string' ? item.data_solicitacao.split('/').reverse().join('-') : item.data_solicitacao;
            item.data_previsao = typeof item.data_previsao === 'string' ? item.data_previsao.split('/').reverse().join('-') : item.data_previsao;
            item.data_entrega = typeof item.data_entrega === 'string' ? item.data_entrega.split('/').reverse().join('-') : item.data_entrega;
            item.data_faturamento = typeof item.data_faturamento === 'string' ? item.data_faturamento.split('/').reverse().join('-') : item.data_faturamento;
            return item;
          });
        })
        .catch(logout);
    },
    converteEmbalagemValor({multiplo_compra, tipo_fator_conversao}, valor) {
      if (tipo_fator_conversao === 'D') {
        return this.embalagemMasterAtivada ? (valor / multiplo_compra) : valor;
      }

      return this.embalagemMasterAtivada ? (valor * multiplo_compra) : valor;
    },
    itemClass(item) {
      return {
        'text-red': item.qtde_pendente > 0 && !item.pedido_desconsiderado,
        'text-gray-100': item.pedido_desconsiderado,
      };
    },
    updatePedidoEmTransitoDesconsiderado() {
      this.getDadosUltimasCompras();
      this.compras_selecionadas = [];
      this.$emit('update:desconsiderar-pedido-em-transito', {});
      this.atualizar_listagem_produtos = true;
    },
    formatarData(data) {
      if (typeof data !== 'string') return data;
      return data.split('-').reverse().join('/');
    }
  }
}
</script>
